var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrectEntries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33464 4H26.668C28.1346 4 29.3346 5.2 29.3346 6.66667V25.3333C29.3346 26.8 28.1346 28 26.668 28H5.33464C3.86797 28 2.66797 26.8 2.66797 25.3333V6.66667C2.66797 5.2 3.86797 4 5.33464 4ZM6.66797 22.6667H13.3346V20H6.66797V22.6667ZM6.66797 17.3333H13.3346V14.6667H6.66797V17.3333ZM6.66797 12H13.3346V9.33333H6.66797V12ZM24.3628 11.6923L25.2305 12.56L21.7905 16L25.2305 19.44L24.3628 20.3077L20.9228 16.8677L17.4828 20.3077L16.6151 19.44L20.0551 16L16.6151 12.56L17.4828 11.6923L20.9228 15.1323L24.3628 11.6923Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrectEntries);
export default __webpack_public_path__ + "static/media/incorrect-entries.e30c075d58bb319cca1514f253628cf7.svg";
export { ForwardRef as ReactComponent };